import React, { useState, useEffect } from "react";
import {
  Container,
  Head,
  Name,
  UsageRow,
  Dot,
  Strong,
  Slash,
  Weak,
  MeterRow,
  Meter,
  Fill,
  PctText,
  SkelName,
  SkelChip,
  SkelDot,
  SkelBar,
  SkelPct,
} from "./styles";
import { getTaskData } from "api/taskStatus";
import { storageAPI } from "api";

const usageColor = (pct) =>
  pct >= 90
    ? "#ef4444"
    : pct >= 80
      ? "#f97316"
      : pct >= 70
        ? "#eab308"
        : "#22c55e";

const Aggregate = ({ aggregateName }) => {
  const [data, setData] = useState();
  useEffect(() => {
    (async () => {
      if (!aggregateName) return;

      const task_result = await getTaskData(() =>
        storageAPI.getAggregatesDetail(aggregateName)
      );

      if (task_result?.status === "SUCCESS") {
        setData(task_result.result.data);
      }
    })();
  }, [aggregateName]);

  if (!data || !aggregateName) {
    return (
      <Container aria-busy="true">
        <Head>
          <Name>
            <SkelName />
          </Name>
          <UsageRow>
            <SkelDot />
            <SkelChip />
            <Slash>/</Slash>
            <SkelChip />
          </UsageRow>
        </Head>

        <MeterRow>
          <Meter>
            <SkelBar />
          </Meter>
          <PctText $color="#94a3b8">
            <SkelPct />
          </PctText>
        </MeterRow>
      </Container>
    );
  }

  const GB = 1024 ** 3;
  const TB = 1024 ** 4;

  // 전체 size 기준으로 단위 선택 (TB or GB)
  const isTB = data.size >= TB;
  const unit = isTB ? "TB" : "GB";

  const used = (data.used / (isTB ? TB : GB)).toFixed(1);
  const size = (data.size / (isTB ? TB : GB)).toFixed(1);

  const percent = data.used_percent;

  const color = usageColor(data.used_percent);

  return (
    <Container>
      <Head>
        <Name>{aggregateName}</Name>

        <UsageRow>
          <Dot $color={color} />
          <Strong>{`${used}${unit}`}</Strong>
          <Slash>/</Slash>
          <Weak>{`${size}${unit}`}</Weak>
        </UsageRow>
      </Head>

      <MeterRow>
        <Meter>
          <Fill $pct={percent} $color={color} />
        </Meter>
        <PctText $color={color}>{percent}%</PctText>
      </MeterRow>
    </Container>
  );
};

export default Aggregate;
